import {
  Settings as SettingsIcon,
  PersonPinCircle as PersonPinCircleIcon,
} from '@material-ui/icons';
// third-party
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import paths from 'paths';
import { ccTypes } from 'store/constant';
// constant

// -----------------------|| SETTINGS MENU ITEMS ||-----------------------//

// eslint-disable-next-line import/prefer-default-export
export default {
  id: 'settings',
  title: 'settings',
  type: 'group',
  isSuperuser: true,
  children: [
    {
      id: 'general',
      title: 'General',
      type: 'item',
      url: paths.settingsGeneral.reverse(),
      icon: SettingsIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal],
    },
    {
      id: 'tags',
      title: 'Tags',
      type: 'item',
      url: paths.settingsTags.reverse(),
      icon: LocalOfferIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal],
    },
    {
      id: 'state-ownership',
      title: 'State Ownership',
      type: 'item',
      url: paths.settingsStateOwnership.reverse(),
      icon: PersonPinCircleIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal],
    },
  ],
};
